import * as React from 'react';
import { colors } from '../../../index';

const IconTrend = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 34 33",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.591 28.952h1.296v2.632H2.591zm9.069-6.58h1.296v9.212H11.66zm9.068 5.264h1.296v3.948h-1.296zm9.069-10.528h1.296v14.476h-1.296z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.307,
    cy: 7.238,
    r: 1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.445,
    cy: 3.29,
    r: 1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.182 23.688H1.296c-.715 0-1.296.59-1.296 1.316V32.9h6.478v-7.896c0-.726-.581-1.316-1.296-1.316zm0 1.316v1.316H1.296v-1.316h3.886zm-3.886 6.58v-3.948h3.886v3.948H1.296zM14.25 17.108h-3.886c-.714 0-1.295.59-1.295 1.316V32.9h6.477V18.424c0-.726-.58-1.316-1.295-1.316zm0 1.316v1.316h-3.886v-1.316h3.887zm-3.886 13.16V21.056h3.887v10.528h-3.887zm12.956-9.212h-3.887c-.715 0-1.296.59-1.296 1.316V32.9h6.478v-9.212c0-.726-.581-1.316-1.296-1.316zm0 1.316v1.316h-3.887v-1.316h3.886zm-3.887 7.896V26.32h3.886v5.264h-3.886zm12.955-19.74H28.5c-.714 0-1.295.59-1.295 1.316V32.9h6.477V13.16c0-.726-.58-1.316-1.295-1.316zm0 1.316v1.316H28.5V13.16h3.887zM28.5 31.584V15.792h3.887v15.792H28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.18 6.318c.389.169.816.262 1.265.262 1.785 0 3.238-1.476 3.238-3.29S32.23 0 30.445 0c-1.786 0-3.24 1.476-3.24 3.29 0 .884.35 1.684.91 2.277L23.1 12.36a3.17 3.17 0 00-1.724-.516c-.774 0-1.476.288-2.033.75L15.028 9.01a3.299 3.299 0 00.518-1.771c0-1.814-1.453-3.29-3.239-3.29-1.785 0-3.238 1.476-3.238 3.29 0 .559.15 1.077.393 1.54L5.2 12.533a3.175 3.175 0 00-1.961-.69C1.453 11.844 0 13.32 0 15.134s1.453 3.29 3.239 3.29c1.786 0 3.239-1.476 3.239-3.29 0-.586-.164-1.128-.43-1.606L10.29 9.79a3.175 3.175 0 002.018.738c.674 0 1.3-.21 1.819-.57l4.396 3.654c-.238.457-.385.97-.385 1.522 0 1.814 1.453 3.29 3.239 3.29 1.786 0 3.239-1.476 3.239-3.29 0-.69-.212-1.33-.57-1.859l5.135-6.957zm1.265-5.002c1.07 0 1.943.886 1.943 1.974s-.872 1.974-1.943 1.974c-1.072 0-1.944-.886-1.944-1.974s.872-1.974 1.944-1.974zM3.239 17.108c-1.072 0-1.943-.886-1.943-1.974s.871-1.974 1.943-1.974c1.071 0 1.943.886 1.943 1.974s-.872 1.974-1.943 1.974zm9.068-7.896c-1.071 0-1.943-.886-1.943-1.974s.872-1.974 1.943-1.974c1.072 0 1.944.886 1.944 1.974s-.872 1.974-1.944 1.974zm9.069 7.896c-1.071 0-1.943-.886-1.943-1.974s.872-1.974 1.943-1.974c1.071 0 1.943.886 1.943 1.974s-.872 1.974-1.943 1.974z"
  })));
};

export default IconTrend;